<template>
  <a-modal v-model="visible" title="授权渠道商 " @ok="handleOk">
      <template slot="footer">
            <a-button key="submit" type="primary"  @click="handleOk">
            确定
            </a-button>
            <a-button key="back"  @click="handleCancel" >
            取消
            </a-button>
        </template>
    <a-transfer
      :data-source="channelPartners"
      :titles="['全部渠道商', '已选择']"
      :showSelectAll="false"
      :target-keys="targetKeys"
      :selected-keys="selectedKeys"
      :render="item => item.title"
      :disabled="disabled"
      @change="handleChange"
      @selectChange="handleSelectChange"
    />
  </a-modal>
</template>
<script>
export default {
  data() {
    // const oriTargetKeys = mockData.filter(item => +item.key % 3 > 1).map(item => item.key);
    return {
      visible: false,
      targetKeys: [],
      selectedKeys: [],
      disabled: false,
      channelPartners:[],
      primaryCategoryId:'',
    };
  },
  methods: {
    init(){
      this.$http.post('distributor/getAllDistributor').then((res)=>{
        let channelRows =res.rows;
        let channelPartners = [];
        if (channelRows&&channelRows.length>0) {
          channelRows.map((item,index)=>{
            let channel = item.split(':');
            channelPartners.push({
              title:channel[1],
              key:channel[0],
              disabled:false,
              description:''
              })
          })
        }
        this.channelPartners = channelPartners;
      })
    },
    showModal(primaryCategoryId) {
      this.init();
      this.primaryCategoryId = primaryCategoryId;
      this.visible = true;
    },
    handleOk(e) {
      let params = {
        distributorIds:this.selectedKeys,
        primaryCategoryId:this.primaryCategoryId,
      }
      this.$http.post('merchandise/batchAuthPriCate',params).then(res=>{
        if (res.result) {
          this.$message.success('授权成功');
          this.handleCancel();
        }else{
          this.$message.warning(res.message);
        }
        
      })
      this.visible = false;
    },
    handleCancel(e) {
      this.selectedKeys = [];
      this.targetKeys = [];
      this.visible = false;
    },
    handleChange(nextTargetKeys, direction, moveKeys) {
      this.targetKeys = nextTargetKeys;
      this.selectedKeys =nextTargetKeys;
    },
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.ant-transfer-list-header-selected{
    span:first-child{
        visibility: hidden
    }

}
/deep/.ant-btn-primary {
    background-color: #1890ff!important;
    border-color: #1890ff!important;
} 
.ant-btn-primary:hover, .ant-btn-primary:focus {
    // background-color: #2374DE!important;
    // border-color: #2374DE!important;
}
.ant-btn-primary:active, .ant-btn-primary.active {
  // background-color: #0040AB;
  // border-color: #0040AB;
}
</style>
